import * as actions from './actions';
import * as userActions from '../user/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';
import { displayDigestsAs } from '~utils/filters';

const initialState = {
    displayAs: displayDigestsAs.grid,
};

export const digestsDisplayReducer = (state = initialState, action) => {
    switch (action.type) {
        // DisplayedBy
        case actions.DIGESTS_CHANGE_DISPLAY:
            return {
                ...state,
                displayAs: action.displayAs,
            };

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/digestsDisplay/reducer.js